var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popular-badge",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm.$t('components.menuItem.popular'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }